import { render } from "./PaginationSelection.vue?vue&type=template&id=623a6294&scoped=true"
import script from "./PaginationSelection.vue?vue&type=script&lang=js"
export * from "./PaginationSelection.vue?vue&type=script&lang=js"

import "./PaginationSelection.vue?vue&type=style&index=0&id=623a6294&scoped=true&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623a6294"]])

export default __exports__